import React, { useEffect, useState } from 'react'
import colors from '../../colors'
import { selectUserInfo } from '../../../features/userInfo/userInfoSlice';
import { useDispatch, useSelector } from 'react-redux';
import { BasicAccountDashboard } from './BasicAccountDashboard'
import EWalletAccountDashboard from './EWalletAccountDashboard'
import { useNavigate } from "react-router-dom";
import { makeStyles } from '@mui/styles';
import CreatePinDialog from '../../general/sca/CreatePinDialog';
import { selectLoginState, setHasPinBeenRegistered } from '../../../features/login/loginSlice';

const Dashboard = () => {
    const spaceshipCardGrid = React.useRef(null)
    const userInfo = useSelector(selectUserInfo)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const loginSliceState = useSelector(selectLoginState)

    const useStyles = makeStyles({
        spaceshipCardGrid: {
            marginTop: '5%',
            '@media (max-width: 899px)': { justifyContent: 'center' }
        },
        purpleCard: {
            borderRadius: '20px',
            width: '60%',
            background: colors.purple,
            '@media (max-width: 1440px)': { width: '80%' },
            '@media (max-width: 899px)': { width: '80%' }
        },
        spaceshipCardGridTitle: {
            color: colors.white,
            fontSize: '1rem',
            fontFamily: 'GerberaBold',
            paddingTop: '3%',
            paddingBottom: '3%',
            textAlign: 'left'
        },
        spaceshipCardGridText: {
            color: colors.white,
            fontFamily: 'GerberaLight',
            fontSize: '0.8rem',
            textAlign: 'left'
        },
        balanceCard: {
            borderRadius: '20px',
            marginBottom: '40px',
            width: '60%',
            height: '125px',
            boxShadow: '0 0 15px 5px #E5E7EA',
            '@media (max-width: 1440px)': { width: '80%' },
            '@media (max-width: 899px)': { width: '90%' }
        },
        exchangeCard: {
            borderRadius: '20px',
            width: '60%',
            marginTop: '50px',
            boxShadow: '0 0 15px 5px #E5E7EA',
            '@media (max-width: 1440px)': { width: '80%' },
            '@media (max-width: 899px)': { width: '90%' }
        },
        newsCard: {
            background: colors.white,
            fontFamily: 'GerberaMedium',
            borderRadius: '20px',
            width: '100%',
            height: '125px',
            paddingTop: '0px',
            // paddingLeft: '30px',
            boxShadow: '0 0 15px 5px #E5E7EA',
            '@media (max-width: 1440px)': { width: '80%' },
            '@media (max-width: 899px)': { width: '90%' }
        },
        title: {
            top: '0',
            width: '100%',
            transform: 'translateX(-2%)',
            background: colors.gradientOrange,
            padding: '8px 20px',
            borderTopRightRadius: '10px',
            borderTopLeftRadius: '10px',
            color: colors.white,
            fontFamily: 'GerberaLight',
            fontSize: '1rem',
        },
        topUpButton: {
            background: colors.darkBlue,
            fontSize: '0.8rem',
            fontFamily: 'GerberaMedium',
            textTransform: 'none',
            color: colors.white,
            borderRadius: '20px',
            width: "100%",
            '@media (max-width: 1200px)': { width: '90%', mr: '15%' },
            "&:hover": { background: colors.gradientOrange }
        },
        iconButton: {
            "&:hover": {
                borderRadius: '100%',
                transition: '.25s ease-in-out',
                backgroundColor: '#F3E5DB'
            },
            width: 'auto',
            height: 'auto',
            borderRadius: '100%',
            // '@media (max-width: 1920px)' : {width:'100%', height:'100%'},
            // '@media (max-width: 1440px)' : {width:'100%', height:'100%'},
            // '@media (max-width: 1024px)' : {width:'120px', height:'120px'},
            // '@media (max-width: 899px)' : {width:'200px', height:'200px'},
            // '@media (max-width: 768px)' : {width:'150px', height:'150px'},
            // '@media (max-width: 425px)' : {width:'130px', height:'130px'},
            // '@media (max-width: 375px)' : {width:'125px', height:'125px'}
        },
        iconButtonTitle: {
            color: colors.darkBlue,
            fontFamily: 'GerberaBold'
        },
        lastCard: {
            width: '60%',
            borderRadius: '20px',
            '@media (max-width: 1440px)': { width: '80%' },
            '@media (max-width: 899px)': { width: '80%' },
            '@media (max-width: 425px)': { marginTop: '-15%' }
        }
    })

    const classes = useStyles()

    return (
        <>
            {userInfo.accountType !== 3
                ? <EWalletAccountDashboard classes={classes} navigate={navigate} userInfo={userInfo} spaceshipCardGrid={spaceshipCardGrid} />
                : <BasicAccountDashboard classes={classes} navigate={navigate} userInfo={userInfo} spaceshipCardGrid={spaceshipCardGrid} />}
            <CreatePinDialog isDialogOpened={!loginSliceState.hasPinBeenRegistered} handleClose={() => {dispatch(setHasPinBeenRegistered(true))}} />
        </>
    )
}

export default Dashboard

